import { call, put, takeEvery, takeLatest } from 'redux-saga/effects'
 
const actionTypes={
    typeTets:"typeTest [Action]",
    typeTetsAsync:"typeTetsAsync [Action]"
}
const inistiaState = {
    data:''
}

export const reducer = (state=inistiaState,{type,payload})=>{
    switch (type) {
        case actionTypes.typeTets:
            return {
                data: payload
            }
        default:
            return state;
    }
}


function* handleWorker() {
    yield({type:actionTypes.typeTets,payload:1})
}

export function* mySaga () {
  yield takeEvery(actionTypes.typeTetsAsync, handleWorker);
}



